<template>
  <div class="infoExams">
    <div>
      <h2>Você vai realizar procedimento(s) de:</h2>
      <ul v-for="examType in listUniqueExamTypes" :key="examType">
        <li class="infoExams-item">{{ examType }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    examList: Array,
  },

  computed: {
    listUniqueExamTypes() {
      const DIAGNOSTICO_POR_IMAGEM = 3;
      const listExams = this.examList.reduce((acc, exam) => {
        if (exam.category.id === DIAGNOSTICO_POR_IMAGEM) {
          acc.push(exam.speciality.name);
        } else {
          acc.push(exam.category.name);
        }
        return acc;
      }, []);

      return new Set(listExams);
    },
  },
};
</script>

<style lang="scss" scoped>
.infoExams {
  margin-top: 24px;
  padding: 24px;
  background-color: white;
  border-radius: 8px;
  border: 1px solid var(--color-neutral-20);

  h2 {
    font-size: 16px;
    color: #161616;
    padding-bottom: 24px;
    font-weight: 500;
  }

  li {
    color: #363636;
    list-style: inside;
    text-transform: lowercase;
  }

  li:first-letter {
    text-transform: uppercase;
  }

  &-item {
    text-align: start;
    padding-left: 26px;
  }
}
</style>
